package br.com.vvrefeicoes.portal.domain.model

/** Gestoras vinculadas a uma diretora (pelo nome). */
fun OrgChartData.managerNamesOfDirector(directorName: String): List<String> {
    val directorId = directors.firstOrNull { it.name.equals(directorName, ignoreCase = true) }?.id ?: return emptyList()
    return managersOfDirector(directorId).map { it.name }
}

/** Unidades (nomes) em que a diretora está vinculada. */
fun OrgChartData.companyNamesOfDirector(directorName: String): Set<String> {
    val directorId = directors.firstOrNull { it.name.equals(directorName, ignoreCase = true) }?.id ?: return emptySet()
    return companies
        .filter { company -> !company.inactive && companyLinks[company.id].orEmpty().any { it.directorId == directorId } }
        .map { it.name }
        .toSet()
}

/** Unidades (nomes) em que a gestora está vinculada. */
fun OrgChartData.companyNamesOfManager(managerName: String): Set<String> {
    val managerId = managers.firstOrNull { it.name.equals(managerName, ignoreCase = true) }?.id ?: return emptySet()
    return companies
        .filter { company -> !company.inactive && companyLinks[company.id].orEmpty().any { it.managerId == managerId } }
        .map { it.name }
        .toSet()
}
